import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { ChangeCcComponent } from '../change-cc/change-cc.component';

@Component({
  selector: 'app-flight-customize',
  templateUrl: './flight-customize.component.html',
  styleUrls: ['./flight-customize.component.css']
})
export class FlightCustomizeComponent implements OnInit {

  public menu_item_id = '118';
  public add_auth;
  public edit_auth;
  public del_auth;

  model = { 
    'table_name': 'flight', 'flight_id': '0', 'flight_no': '', 'flight_name': '', 'flight_number': '',
    'start_airport': '0', 'end_airport': '0', 'depart_time': '', 'arrival_time': '', 'flight_start_date': '',
    'flight_end_date': '', 'flight_day': '', 'flight_date': '', 'restriction': '', 'ticket_num': '', 
    'airline_id': '', 'return_required': '0', 'adult_price': '0', 'adult_group_price': '0', 'child_price': '0', 
    'child_group_price': '0', 'infant_price': '0', 'infant_group_price': '0', 'return_perc': '0', 
    'return_group_perc': '0', 'cost_center': '0', 'flag': 'update', 'key': 'flight_id', 'comment': ''
  };

  data_model = {
    'dep_time_hr': '', 'dep_time_mm': '', 'dep_time_per': '', 'arr_time_hr': '', 'arr_time_mm': '', 
    'arr_time_per': ''
  };

  hour_list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  min_list = [];
  period_list = [{ 'period': 'AM', 'period_ar': 'صباحاً' }, { 'period': 'PM', 'period_ar': 'مساءاً' }];
  flight_list = [];

  changeDialogRef: MatDialogRef<ChangeCcComponent>;

  Success_Msg; Error_Msg; Del_Flight_Msg; 
  Depart_Time_Msg; Arrival_Time_Msg;
  Adult_Price_Msg; Child_Price_Msg; Infant_Price_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService, private route: ActivatedRoute, 
    private router: Router) { 
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Flight_Msg').subscribe((res: string) => {
      this.Del_Flight_Msg = res;
    });

    translate.get('Depart_Time_Msg').subscribe((res: string) => {
      this.Depart_Time_Msg = res;
    });

    translate.get('Arrival_Time_Msg').subscribe((res: string) => {
      this.Arrival_Time_Msg = res;
    });

    translate.get('Adult_Price_Msg').subscribe((res: string) => {
      this.Adult_Price_Msg = res;
    });

    translate.get('Child_Price_Msg').subscribe((res: string) => {
      this.Child_Price_Msg = res;
    });

    translate.get('Infant_Price_Msg').subscribe((res: string) => {
      this.Infant_Price_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    this.min_list = [];
    for (let index = 0; index < 60; index++) {
      if (index < 10)
        this.min_list.push('0' + index);
      else 
        this.min_list.push(index.toString());
    }

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.model['flight_no'] = params['no'];

        // get flight detail
        let query = "SELECT `flight`.*, `airport`.`airport_name` AS `start_airport_name`, " + 
          "`airport`.`airport_name_en` AS `start_airport_name_en`, `airport`.`airport_code` " + 
          "AS `start_airport_code`, (CASE WHEN `flight`.`airline_id` != '0' THEN " + 
          "(SELECT `airline`.`airline_name` FROM `airline` WHERE `airline`.`airline_id` = `flight`.`airline_id`) " + 
          "ELSE '' END) AS 'airline_name', (CASE WHEN `flight`.`airline_id` != '0' THEN " + 
          "(SELECT `airline`.`airline_name_en` FROM `airline` WHERE " + 
          "`airline`.`airline_id` = `flight`.`airline_id`) ELSE '' END) AS 'airline_name_en', " + 
          "(CASE WHEN `flight`.`end_airport` != '0' THEN (SELECT `airport`.`airport_name` FROM " + 
          "`airport` WHERE `flight`.`end_airport` = `airport`.`airport_id`) ELSE '' END) " + 
          "AS 'end_airport_name', (CASE WHEN `flight`.`end_airport` != '0' THEN " + 
          "(SELECT `airport`.`airport_name_en` FROM `airport` WHERE " + 
          "`flight`.`end_airport` = `airport`.`airport_id`) ELSE '' END) AS 'end_airport_name_en', " + 
          "(CASE WHEN `flight`.`end_airport` != '0' THEN (SELECT `airport`.`airport_code` FROM `airport` " + 
          "WHERE `flight`.`end_airport` = `airport`.`airport_id`) ELSE '' END) AS 'end_airport_code'" + 
          "FROM `flight`, `airport` WHERE `flight`.`flight_no` = '" + this.model['flight_no'] + 
          "' AND `flight`.`status` = '1' AND `flight`.`start_airport` = `airport`.`airport_id`";

        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.flight_list = data.data['list'];

            this.model['flight_name'] = this.flight_list[0]['flight_name'];
            this.model['flight_number'] = this.flight_list[0]['flight_number'];
            this.model['flight_id'] = this.flight_list[0]['flight_id'];

            this.model['start_airport'] = this.flight_list[0]['start_airport'];
            this.model['end_airport'] = this.flight_list[0]['end_airport'];

            this.model['flight_date'] = this.flight_list[0]['flight_date'];
            this.model['flight_day'] = this.flight_list[0]['flight_day'];

            this.model['restriction'] = this.flight_list[0]['restriction'];
            this.model['ticket_num'] = this.flight_list[0]['ticket_num'];
            this.model['airline_id'] = this.flight_list[0]['airline_id'];
            this.model['return_required'] = this.flight_list[0]['return_required'];

            this.model['depart_time'] = this.flight_list[0]['depart_time'];
            this.data_model['dep_time_hr'] = this.flight_list[0]['depart_time'].substring(0, 2);
            this.data_model['dep_time_mm'] = this.flight_list[0]['depart_time'].substring(3, 5);
            this.data_model['dep_time_per'] = this.flight_list[0]['depart_time'].substring(6);

            this.model['arrival_time'] = this.flight_list[0]['arrival_time'];
            this.data_model['arr_time_hr'] = this.flight_list[0]['arrival_time'].substring(0, 2);
            this.data_model['arr_time_mm'] = this.flight_list[0]['arrival_time'].substring(3, 5);
            this.data_model['arr_time_per'] = this.flight_list[0]['arrival_time'].substring(6);

            this.model['flight_start_date'] = this.flight_list[0]['flight_start_date'];
            this.model['flight_end_date'] = this.flight_list[0]['flight_end_date'];

            this.model['adult_price'] = this.flight_list[0]['adult_price'];
            this.model['adult_group_price'] = this.flight_list[0]['adult_group_price'];
            this.model['child_price'] = this.flight_list[0]['child_price'];
            this.model['child_group_price'] = this.flight_list[0]['child_group_price'];
            this.model['infant_price'] = this.flight_list[0]['infant_price'];
            this.model['infant_group_price'] = this.flight_list[0]['infant_group_price'];
            this.model['return_perc'] = this.flight_list[0]['return_perc'];
            this.model['return_group_perc'] = this.flight_list[0]['return_group_perc'];
            this.model['cost_center'] = this.flight_list[0]['cost_center'];
            this.model['comment'] = this.flight_list[0]['comment'];
          });
      }
    });

  }

  viewDetail() {
     // get the flight detail for the selected flight
     for (let index = 0; index < this.flight_list.length; index++) {
      if (this.flight_list[index]['flight_id'] == this.model['flight_id']) {

        this.model['flight_date'] = this.flight_list[index]['flight_date'];
        this.model['flight_day'] = this.flight_list[index]['flight_day'];

        this.model['depart_time'] = this.flight_list[index]['depart_time'];
        this.data_model['dep_time_hr'] = this.flight_list[index]['depart_time'].substring(0, 2);
        this.data_model['dep_time_mm'] = this.flight_list[index]['depart_time'].substring(3, 5);
        this.data_model['dep_time_per'] = this.flight_list[index]['depart_time'].substring(6);

        this.model['arrival_time'] = this.flight_list[index]['arrival_time'];
        this.data_model['arr_time_hr'] = this.flight_list[index]['arrival_time'].substring(0, 2);
        this.data_model['arr_time_mm'] = this.flight_list[index]['arrival_time'].substring(3, 5);
        this.data_model['arr_time_per'] = this.flight_list[index]['arrival_time'].substring(6);

        this.model['adult_price'] = this.flight_list[index]['adult_price'];
        this.model['adult_group_price'] = this.flight_list[index]['adult_group_price'];
        this.model['child_price'] = this.flight_list[index]['child_price'];
        this.model['child_group_price'] = this.flight_list[index]['child_group_price'];
        this.model['infant_price'] = this.flight_list[index]['infant_price'];
        this.model['infant_group_price'] = this.flight_list[index]['infant_group_price'];
        this.model['return_perc'] = this.flight_list[index]['return_perc'];
        this.model['return_group_perc'] = this.flight_list[index]['return_group_perc'];
        this.model['cost_center'] = this.flight_list[index]['cost_center'];
        this.model['comment'] = this.flight_list[index]['comment'];
        
        break;
      }
    }
  }

  changeCC() {

    let dialog_data = [{
        'table_name': 'flight', 'id': this.model['flight_id'], 'cost_center': this.model['cost_center'] 
        }];
    
        this.changeDialogRef = this.dialog.open(ChangeCcComponent, {
          hasBackdrop: false,
          data: dialog_data
        });
        this.changeDialogRef
          .afterClosed()
          .subscribe(result => {
            if (result != null && result['op_type'] == 'success') {
              this.ngOnInit();
            }
          });
  }

  cancel() {
    if (confirm(this.Del_Flight_Msg)) {
      let obj;

      let values = [];
      values.push({ 'table_name': this.model['table_name'], 'flight_id': this.model['flight_id'] });

      let query = "SELECT `invoice_no` FROM `invoice`, `flight` WHERE " + 
        "`invoice`.`flight_id` = '" + this.model['flight_id'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let invoice_list = data.data['list'];

          invoice_list.forEach(element => {
            values.push({ 'table_name': 'invoice', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'invoice_item', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'inv_payment_method', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'trip_group', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'reg_on_ticket', 'invoice_no': element.invoice_no });
          });

          obj = { cmd: 'deleteRec', values: values };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              if (data.status['type'] == 'success') {
                alert(this.Success_Msg);
                this.ngOnInit();
              }
              else {
                alert(this.Error_Msg);
              }
            });
        });
    }
  }

  save() {
    if (this.data_model['dep_time_hr'] == '' || this.data_model['dep_time_mm'] == '' || 
      this.data_model['dep_time_per'] == '') {
        alert(this.Depart_Time_Msg);
        return;
    }

    if (this.data_model['arr_time_hr'] == '' || this.data_model['arr_time_mm'] == '' || 
      this.data_model['arr_time_per'] == '') {
        alert(this.Arrival_Time_Msg);
        return;
    }

    if (this.model['adult_price'] == '' || isNaN(Number(this.model['adult_price']))) {
      alert(this.Adult_Price_Msg);
      return;
    }

    if (this.model['child_price'] == '' || isNaN(Number(this.model['child_price']))) {
      alert(this.Child_Price_Msg);
      return;
    }

    if (this.model['infant_price'] == '' || isNaN(Number(this.model['infant_price']))) {
      alert(this.Infant_Price_Msg);
      return;
    }

    let values = [];
    let obj;

    this.model['depart_time'] = this.data_model['dep_time_hr'] + ":" + this.data_model['dep_time_mm'] + 
      " " + this.data_model['dep_time_per'];

    this.model['arrival_time'] = this.data_model['arr_time_hr'] + ":" + this.data_model['arr_time_mm'] + 
      " " + this.data_model['arr_time_per'];

    values.push(this.model);
    obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.ngOnInit();
        }
        else 
          alert(this.Error_Msg);
      });
  }

}
